export default "__VITE_ASSET__nnZCuJcI__"